<div class="nlc-card">
  <div class="nlc-card-header">
    <div class="nlc-card-icon">
      <mat-icon>receipt_long</mat-icon>
    </div>
    <div class="nlc-card-title-section">
      <h3>Auftrag</h3>
      <p>Auftrags Nr: {{ gatewayOrder?.orderNo }}</p>
    </div>
  </div>
  <div class="nlc-card-content">
    <div class="nlc-info-row highlight-row">
      <span class="nlc-info-label">Kundennummer</span>
      <span class="nlc-info-value">{{ customer?.reflexCustomerNo }}</span>
    </div>
    <div class="nlc-info-row">
      <span class="nlc-info-label">Zeitraum</span>
      <span class="nlc-info-value">
        {{ gatewayOrder?.dateFrom | date:'dd.MM.yyyy' }} - {{ gatewayOrder?.dateTo | date:'dd.MM.yyyy' }}
      </span>
    </div>
    <div class="nlc-info-row">
      <span class="nlc-info-label">Firma</span>
      <span class="nlc-info-value">{{ gatewayOrder?.companyName }}</span>
    </div>
    <div class="nlc-info-row">
      <span class="nlc-info-label">Abgerechnet</span>
      <span class="nlc-info-value">
        <mat-icon class="status-icon" [class.status-success]="gatewayOrder?.isBilled" [class.status-error]="!gatewayOrder?.isBilled"
          matTooltip="{{ gatewayOrder?.isBilled ? 'Ja' : 'Nein' }}" matTooltipPosition="right">
          {{ gatewayOrder?.isBilled ? 'check_circle' : 'cancel' }}
        </mat-icon>
      </span>
    </div>
    <div class="nlc-info-row">
      <span class="nlc-info-label">Bezahlt</span>
      <span class="nlc-info-value">
        <mat-icon class="status-icon" [class.status-success]="gatewayOrder?.isPaid" [class.status-error]="!gatewayOrder?.isPaid"
          matTooltip="{{ gatewayOrder?.isPaid ? 'Ja' : 'Nein' }}" matTooltipPosition="right">
          {{ gatewayOrder?.isPaid ? 'check_circle' : 'cancel' }}
        </mat-icon>
      </span>
    </div>
    <div class="nlc-info-row">
      <span class="nlc-info-label">Coins verwendet</span>
      <span class="nlc-info-value">
        <mat-icon class="status-icon" [class.status-success]="order?.coinsUsed! > 0" [class.status-error]="!(order?.coinsUsed! > 0)"
          matTooltip="{{ order?.coinsUsed! > 0 ? 'Ja' : 'Nein' }}" matTooltipPosition="right">
          {{ order?.coinsUsed! > 0 ? 'check_circle' : 'cancel' }}
        </mat-icon>
      </span>
    </div>
    <div class="nlc-info-row" *ngIf="order?.status?.name">
      <span class="nlc-info-label">Coin-Status</span>
      <span class="nlc-info-value">
        <mat-icon class="status-icon" 
          [class.status-success]="order?.status?.name === 'Genehmigt'"
          [class.status-error]="order?.status?.name === 'Abgelehnt'"
          [class.status-warning]="order?.status?.name === 'Ausstehend'"
          [matTooltip]="order?.status?.name" matTooltipPosition="right">
          {{ order?.status?.name === 'Genehmigt' ? 'check_circle' : order?.status?.name === 'Abgelehnt' ? 'cancel' : 'hourglass_empty' }}
        </mat-icon>
      </span>
    </div>
    <div class="nlc-info-row" *ngIf="order?.coinsUsed && order?.coinsUsed! > 0">
      <span class="nlc-info-label">Coins verwendet (Anzahl)</span>
      <span class="nlc-info-value">{{ order?.coinsUsed }}</span>
    </div>
    <div class="nlc-info-row" *ngIf="order?.coinsUsed && order?.coinsUsed! > 0 && order?.customer">
      <span class="nlc-info-label">Coins verwendet von</span>
      <span class="nlc-info-value">
        {{ order?.customer?.userDetails?.firstName }} {{ order?.customer?.userDetails?.lastName }}
      </span>
    </div>
  </div>
</div>